import { GA } from '@gamiphy/analytics';

export const trackEmailSent = (): void => GA.trackEvent('referrals', 'email_sent');
export const trackCopyClicked = (): void => GA.trackEvent('referrals', 'copy_clicked');
export const trackWhatsappClicked = (): void => GA.trackEvent('referrals', 'whatsapp_clicked');
export const trackInviteClicked = (): void => GA.trackEvent('referrals', 'invite_clicked');
